//scroll variable to track window's scroll
var lastScrollTop = 0;
var mobileW = 0;

//vanilla variables for resizing 
var w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

//datepicker booking
var opened = 0;
var start = $('#startdate').attr('value');
var end = $('#enddate').attr('value');
var opencheck = 0;
var firstClick = 0;

var logoUrl = site_url + 'assets/svg/logo-2.svg';


resizeWindow();
scrollW();

// Func = limiting Scope for this file
(function(){
	
	window.onload = function() {
		resizeWindow();
		scrollW();
	};

	window.addEventListener('scroll', function(){
		scrollW();
	})
	window.addEventListener('resize', function(){
		resizeWindow();
	});

	//scroll down click
	if(document.getElementsByClassName('scroll-down').length > 0){
		document.getElementsByClassName('scroll-down')[0].addEventListener('click', function(){
			animateTo('intro');
		});
	}
	if(window.innerWidth <= 768){
		if(document.getElementsByClassName('planning-btn').length > 0){
			document.getElementsByClassName('planning-btn')[0].addEventListener('click', function(e){
				e.preventDefault();
				if(!document.getElementById('planningForm').classList.contains('top')){
					document.querySelector('html').style.overflow = "hidden";
					document.querySelector('#planningForm .container').style.overflow = "scroll";
					document.getElementById('planningForm').classList.add('open');
					document.getElementById('planningForm').classList.remove('closed');
				}
			});
			document.getElementsByClassName('planning-btn')[1].addEventListener('click', function(e){
				e.preventDefault();
				document.getElementById('planningForm').classList.remove('top')
				if(!document.getElementById('planningForm').classList.contains('open')){
					this.innerHTML = 'Close Form';
					document.querySelector('html').style.overflow = "hidden";
					document.querySelector('#planningForm .container').style.overflow = "scroll";
					document.getElementById('planningForm').classList.add('open');
					document.getElementById('planningForm').classList.remove('closed');
				} else {
					this.innerHTML = 'Request Proposal';
					document.getElementById('planningForm').classList.remove('open');
					document.getElementById('planningForm').classList.add('closed');
					document.querySelector('html').style.overflow = null ;
				}
			});
		}
	} else {
		document.getElementsByClassName('planning-btn')[0].addEventListener('click', function(e){
			e.preventDefault();
			animateTo(this.getAttribute('href').split('#')[1]);
		});
		document.getElementsByClassName('planning-btn')[1].addEventListener('click', function(e){
			e.preventDefault();
			if(!this.classList.contains('tapped')){
				this.classList.add('tapped');
				this.innerHTML = 'Close Form';
				document.getElementById(this.getAttribute('href').split('#')[1]).classList.add('open')
			} else {
				this.classList.remove('tapped');
				this.innerHTML = 'Start Planning';
				document.getElementById(this.getAttribute('href').split('#')[1]).classList.remove('open')
			}
			
		});
	}
	
	if(document.getElementsByClassName('js-close-planning').length > 0){
		document.getElementsByClassName('js-close-planning')[0].addEventListener('click', function(e){
			e.preventDefault();
			document.getElementById('planningForm').classList.remove('open');
			document.getElementById('planningForm').classList.add('closed');
			document.querySelector('html').style.overflow = null;
			document.getElementById('planningForm .container').style.overflow = "hidden";
		});
	}

	
	//startplanning
	if(document.getElementsByClassName('startplanning').length > 0){
		let allstart = document.getElementsByClassName('startplanning');
		let allstartLength = allstart.length;
		for(let p = 0; p < allstartLength; p++){
			allstart[p].addEventListener('click', function(e){
				e.preventDefault();
				
				if(!document.getElementById('planningForm').classList.contains('top')){
					document.getElementById('planningForm').classList.add('open');
					document.getElementById('planningForm').classList.remove('closed');
				}

			});
		}
	}

	//tablet burger menu burgerTablet
	if(document.getElementById('burgerTablet')){
		document.getElementById('burgerTablet').addEventListener('click', function(){
			if(!this.parentElement.classList.contains('open')){
				this.parentElement.classList.add('open');
				document.getElementById('primary-nav').classList.add('open');
				logoUrl = site_url + 'assets/svg/logo-small-2.svg';
				document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
		
			} else {
				this.parentElement.classList.remove('open');
				document.getElementById('primary-nav').classList.remove('open');
				if(!document.getElementsByTagName('header')[0].classList.contains('internal')){
					logoUrl = site_url + 'assets/svg/logo-2.svg';
					document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
				}
			}
		});
	}
	
	//mobile burger menu
	document.getElementById('burgerMenu').addEventListener('click', function(){
		if(!this.classList.contains('open')){
			this.parentElement.classList.add('open');
			this.classList.add('open');
			document.getElementById('primary-nav').classList.add('open');
	
		} else {
			this.classList.remove('open');
			this.parentElement.classList.remove('open');
			document.getElementById('primary-nav').classList.remove('open');
		
		}
	});


	//vanilla JS fancybox
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				if(!document.getElementById(currentTarget).classList.contains('open')){
					document.getElementById(currentTarget).classList.add('open')
				} else {
					document.getElementById(currentTarget).classList.remove('open')
				}
			});
		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				if(!document.getElementById(currentTarget).classList.contains('open')){
					document.getElementById(currentTarget).classList.add('open')
				} else {
					document.getElementById(currentTarget).classList.remove('open')
				}
			});
		}

		//outside click
		// let alllightbox = document.getElementsByClassName('lightbox');
		// let alllightLength = alllightbox.length;
		// for(let j = 0; j < alllightLength; j++ ){
		// 	alllightbox[j].addEventListener('click', function(e){
		// 		//console.log(e.target);
		// 		if(!e.target.classList.contains('slick-arrow')){
		// 			if(this.classList.contains('open')){
		// 				this.classList.remove('open')
		// 			}
		// 		}
				
		// 	});
		// }
	}

	$(document).ready(function(){

		if(windowWidth > 660){
			setTimeout( () => {
				$('#event_date').datepicker();
				$('[name=event_date]').datepicker();
				flatpickr( "[name=event_date]" );
			}, 1000 )
		}
		

		//booking
		$('.js-fake-input').click(function(){
			$('#fakeInput').fadeIn();
		})

		//To create after event 
        $.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
        $.datepicker._updateDatepicker = function(inst) {
            $.datepicker._updateDatepicker_original(inst);
            var afterShow = this._get(inst, 'afterShow');
            if (afterShow)
                afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		}
		

		$('#fakeInput .calendar').datepicker({
			changeMonth: true,
            dateFormat: 'mm/dd/yy',
            numberOfMonths: 1,
        	beforeShowDay: function(date) {
				
            	$.datepicker._defaults.dateFormat = "mm/dd/yy";
            	var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
            	var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
            	if(date.getTime() == startDate.getTime()){
                	return[true,"startday"];
            	} else {
                	if(date.getTime() == endDate.getTime()){
                    	return[true,"endday"];
                	} else {
                    	if(date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()){
                        	return[true,"days"];
                    	} else {
                        	return[true,""];
                    	}
                	}
				} 
        	},
        	onSelect: function (date) {
				

            	var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
            	var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
            	var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);
            	
            	if(opened == 0){
					opened = 1;
                	start = date;
					end =  date; 
					opencheck = 0;
            	} else {
					opened = 0;
					if(selectedDate <= arrive){
						end =  start;
						start = date;  
					} else {
						end =  date; 
					}
					$('#fakeInput').fadeOut();
					opencheck = 1;
					firstClick = 0;
				}
			
				$('#startdate').attr('value',start);
				$('#enddate').attr('value',end);
				$('.js-fake-input').attr('value',start + ' - '+ end);
        	},
            onChangeMonthYear :function(){
				opencheck = 1;
			}
		});

		//click outside
		if(document.getElementById('fakeInput')){
			let specifiedElement = document.getElementById('fakeInput').getElementsByClassName('ui-datepicker')[0]
		
			document.addEventListener('click', function(event) {
				
				let isClickInside = specifiedElement.contains(event.target);
				
				if (!isClickInside) {
					if(firstClick == 0){
						//console.log('first');
						firstClick = 1;
						opencheck = 0;
					} else {
						if(opencheck == 1){
							//console.log('calendario');
							opencheck = 0;
						} else {
							//console.log('out');
							opened = 0;
							opencheck = 0;
							firstClick = 0;
							$('#startdate').attr('value',start);
							$('#enddate').attr('value',end);
							$('.js-fake-input').attr('value',start + ' - '+ end);
							$('#fakeInput').fadeOut();
						}
						
					}
					console.log('nope')
				} else {
					console.log('holi')
				}
				
			});
		}
		if(document.getElementById('event_date')){
			document.getElementById('event_date').addEventListener('change', function(){

				let currentDate = this.value.split(' - ');
				console.log(currentDate[0]);
				$('#startdate').attr('value',currentDate[0]);
				start = currentDate[0];
				$('#enddate').attr('value',currentDate[1]);
				end = currentDate[1];

			});
		}

		setTimeout(() => {
			$('#form_id-4223 [type="date"]').datepicker({
				dateFormat: 'yy-mm-dd',
			});
		}, 1000);

		//get Url parameters
		(function(){
			let hashtable = readUrlParams()
			
			if($('input#source').length>0 && Object.keys(hashtable).length>0){
				let utm_source = hashtable.utm_source
				let gclid = hashtable.gclid
				if(utm_source !== undefined)
					$('input#source').val(utm_source)
				else if(gclid !== undefined)
					$('input#source').val('google')
				else
					$('input#source').val('organic')
			}
		}());
	});

}());

function scrollW(){
	//check scroll down or up for header styles 
	let st = window.pageYOffset || document.documentElement.scrollTop;

		if(st > 150){
			if (st > lastScrollTop){
				// downscroll code
				if(!document.getElementById('header').classList.contains('internal')){
					document.getElementById('header').classList.add('internal');
					logoUrl = site_url + 'assets/svg/logo-small-2.svg';
					document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
				}
			} 
			
			if(document.getElementById('planningForm').classList.contains('top')){
				document.getElementById('planningForm').classList.remove('top');
				document.getElementById('planningForm').classList.add('closed');
				document.getElementById('planningForm').classList.remove('open');
			}
			
		} else {
			if(document.getElementById('home') && document.getElementById('header').classList.contains('internal')){
				document.getElementById('header').classList.remove('internal');
				if(windowWidth > 600){
					logoUrl = site_url + 'assets/svg/logo-2.svg';
					document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
				}
			}
			if(document.getElementById('home') && windowWidth > 600) {
				logoUrl = site_url + 'assets/svg/logo-2.svg';
				document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
				if(!document.getElementById('planningForm').classList.contains('top')){
					document.getElementById('planningForm').classList.remove('closed');
					document.getElementById('planningForm').classList.remove('open');
					document.getElementById('planningForm').classList.add('top');
				}
			}
			// internal pages
			if(!document.getElementById('home') && !document.getElementById('header').classList.contains('internal')){
				logoUrl = site_url + 'assets/svg/logo-small-2.svg';
				document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
				document.getElementById('header').classList.add('internal');
			}
			if(windowWidth < 600){
				if(!document.getElementById('header').classList.contains('internal')){
					document.getElementById('header').classList.add('internal');
					logoUrl = site_url + 'assets/svg/logo-small-2.svg';
					document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
				}
			}
		}
	
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function resizeWindow(){
	//calculate a new window size
	windowWidth = w.innerWidth||e.clientWidth||g.clientWidth;
	windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

	//header image to be window height on homepage
	if(document.getElementsByClassName('img-slide').length > 0){
		let headerImages = document.getElementsByClassName('img-slide');
		let headerImagesLength = headerImages.length;
		for(let i = 0; i < headerImagesLength; i++){
			headerImages[i].style.height = (windowHeight + 10) + 'px';
		}
	}
}

//animation of scroll vanilla JS
function animateTo(target){
	var gotoTarget = offset(document.getElementById(target)).top - 100;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300; 
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {
			
			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

//window offset
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

function readUrlParams() {
	var result = {};
	var hashParam = window.location.search.substring(1);
	var params = hashParam.split("&");
	
	$.each(params, function (index, set) {
		var paramSet = set.split("=");
		if (typeof (paramSet[1]) !== "undefined") {
			result[paramSet[0]] = decodeURIComponent(paramSet[1]);
		} else {
			result[paramSet[0]] = '';
		}
	});
	return result;
}